import type { QueryClient } from '@tanstack/react-query';

let appQueryClient: QueryClient | undefined;

export function setAppQueryClient(queryClient: QueryClient | undefined): void {
  appQueryClient = queryClient;
}

export function getAppQueryClient(): QueryClient | undefined {
  return appQueryClient;
}
